import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useUpdateTaskMutation,
  TaskState,
  useGetTaskDetailsQuery,
} from '@/redux';
import { TaskDetailsModal } from './TaskDetailsModal';
import { notify } from '@/components';

const useSubmit = (closeModal: () => any) => {
  const [updateTask] = useUpdateTaskMutation();

  return async (values: TaskState) => {
    await updateTask(values)
      .unwrap()
      .then(() => {
        notify.success.t('tasks.details.saved');
        closeModal();
      });
  };
};

export function useEditTaskAction() {
  const [id, setId] = useState<string>();
  const { t } = useTranslation();
  const submit = useSubmit(() => setId(undefined));
  const { currentData } = useGetTaskDetailsQuery({ id: id! }, { skip: !id });

  return {
    openEdit: (id: string) => setId(id),
    editModal: (
      <>
        {currentData && (
          <TaskDetailsModal
            title={t('tasks.details.editTitle')}
            buttonSaveName={t('tasks.details.save')}
            onSubmit={submit}
            value={currentData}
            onClose={() => setId(undefined)}
            homeDisabled
          />
        )}
      </>
    ),
  };
}
